export const setupRemoteMedia = (session, has_video = false) => {
  const mediaElement = document.getElementById("mediaElement");

  const remoteStream = new MediaStream();

  session.sessionDescriptionHandler.peerConnection.getReceivers().forEach((receiver) => {
    if (receiver.track) {
      remoteStream.addTrack(receiver.track);
    }
  });

  if (!has_video) {
    mediaElement.srcObject = remoteStream;
    mediaElement.play();
  } else {
    const remoteVideoElement = document.getElementById("remoteVideoElement");
    const localVideoElement = document.getElementById("localVideoElement");

    if (typeof remoteVideoElement !== "undefined" && remoteVideoElement !== null) {
      remoteVideoElement.srcObject = remoteStream;
      remoteVideoElement.play();
    }

    const senderStream = new MediaStream();
    session.sessionDescriptionHandler.peerConnection.getSenders().forEach((sender) => {
      if (sender.track) {
        senderStream.addTrack(sender.track);
      }
    });
    if (typeof localVideoElement !== "undefined" && localVideoElement !== null) {
      localVideoElement.srcObject = senderStream;
      localVideoElement.play();
    }
  }
};

export const connectingCallRigton = (option) => {
  try {
    const ringtone = document.getElementById("connectingRingTone");

    if (option === "play") {
      ringtone?.play();
    }
    if (option === "pause") {
      ringtone?.pause();
    }
  } catch (err) {
    console.log(err);
  }
};

export const InComingCallRington = (option) => {
  const ringtone = document.getElementById("InComingConnectingRingTone");

  if (option === "play") {
    ringtone?.play();
  }
  if (option === "pause") {
    ringtone?.pause();
  }
};

export const getObjectCount = (obj) => Object.keys(obj).length;

export const cleanupMedia = () => {
  console.log("cleaning up");
  try {
    const mediaElement = document.getElementById("mediaElement");
    const remoteVideoElement = document.getElementById("remoteVideo");

    if (typeof remoteVideoElement !== "undefined" && remoteVideoElement != null) {
      remoteVideoElement.srcObject = null;
    }
    const localVideoElement = document.getElementById("localVideo");
    if (typeof localVideoElement !== "undefined" && localVideoElement != null) {
      localVideoElement.srcObject = null;
    }
    mediaElement.srcObject = null;
    mediaElement.pause();
  } catch (err) {
    console.log(err);
  }
};

export const detectAudioVideoPermission = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach((track) => track.stop());
    console.log("Microphone permission granted:", stream);

    return true;
  } catch (err) {
    console.error("Error accessing microphone:", err);
    alert("Microphone permissions not Given");
    return false;
  }
};

export const genrateObjectInitalStateKey = (object) => {
  const newObj = {};
  Object.keys(object).forEach((key) => {
    newObj[key] = key;
  });

  return Object.freeze(newObj);
};

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{1,3}|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? `+${match[1]} ` : "";

    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }

  return phoneNumberString;
};

export const secondsToMinutes = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
};

export const formatDateTime = (dateTimeStr) => {
  const date = new Date(dateTimeStr);

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const day = days[date.getUTCDay()];

  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;

  const time = `${hours}:${String(minutes).padStart(2, "0")} ${ampm}`;

  return { day, time };
};
